import type { StepProps } from '@rulebooks/evidend-titan';
import type { useSaveRegisterMutation } from 'forms/mutation/useSaveRegisterMutation';
import React from 'react';

export type IWizardContext = {
  step: string;
  steps: StepProps[];
  visitStep: (step: string, replace?: boolean) => void;
  visitNextStep: () => void;
  nextStep: string;
  previousStep: string;
} & ReturnType<typeof useSaveRegisterMutation>;

// The default context value should not be used anywhere.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const WizardContext = React.createContext<IWizardContext>(undefined!);
